
import SpeedkitYoutube from '#speedkit/components/SpeedkitYoutube.vue'

export default {
  name: 'Youtube',
  components: { SpeedkitYoutube },
  props: {
    title: {
      required: true,
      type: String,
    },
    uRL: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      youtube: {
        url: '',
        title: '',
        loadingSpinner: undefined,
        host: 'https://www.youtube.com',
        options: {
          fs: false, // use boolean instead of 0 or 1
        },
        posterSizes: {
          default: '100vw',
          md: '50vw',
        },
      },
    }
  },
  created() {
    this.youtube.url = this.uRL
    this.youtube.title = this.title
  },
}
